/*

usage :

require('a')
.require('b')
.define('c',function (imports) {
  



  return export;
})


*/

(function (context) {

var MODULES=window;


var Importer =  function () {
  this.imports = {}
}

Importer.prototype.require=function (name) {
  
  if (MODULES[name]==null) {
    if (console && console.log) console.log("ERROR: module "+name+" was required, but not loaded (yet).");
    // stop executing.
    var dummy = {
        require : function () { return dummy },
        define : function () { return dummy }

    }
  }

  this.imports[name]= MODULES[name];
  return this;

}

Importer.prototype.define=function (name,body) {
  
  MODULES[name]=body(this.imports);

}



context.require = function (name) {
  var importer = new Importer();
  return importer.require(name)

}
context.define = function (name,body) {
  var importer = new Importer();
  return importer.define(name,body)
}



})(window)